import React from "react";
import "../App.css";
import { motion } from "framer-motion";
import TransitionPage from "../TransitionPage";
import DRDO from "../images/drdo1.png";
import CSIR from "../images/csir.png";
import BDL from "../images/bdl.png";
import adani from "../images/adani.png";
import solar from "../images/solar.png";
import hardware from "../images/hardware.png";
import AnimatedElement from "../components/AnimatedElement";
import SVGRND from "../components/SVG/SVG-RND";
import RevealText from "../components/TextReveal2";
import ParticlesComponent from "../components/Particles";
import MissionImg from "../images/leadership.png";
import VisionImg from "../images/vision.png";
import NumberCounter from "../components/NumberCount";
import { MdWorkspacePremium } from "react-icons/md";
import IPC from "../images/Mechanical/ipc2.png";
import ISO from "../images/Mechanical/iso.jpg";
import MSME from "../images/Mechanical/msme.png";
import AS9100 from "../images/Mechanical/as9100.png";
import ZED from "../images/ZedCertificate.png";
import SIDM from "../images/SIDM.png";
import Values2 from "../components/About/Values2";
import BG2 from "../components/SVG/BG2";
import NABL from "../images/Mechanical/NABL.png";
import CII from "../images/Mechanical/CII£.png";
import FactoryAct from "../images/Mechanical/FactoryAct.png";

function Home() {
  return (
    <>
      <TransitionPage>
        <div className=" h-auto relative text-white bg-gray-300">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div className="bg-none">
              <div className="  relative overflow-hidden contain-content h-[100vh]">
                <div className="z-[95] relative">
                  <ParticlesComponent />
                </div>
                <div className="w-full h-full">
                  <BG2 />
                </div>

                <div className="flex items-center w-full  z-[99] absolute top-0  justify-center p-5 h-full ">
                  <svg className="svg-text w-full h-full">
                    <text
                      className="max-sm:text-[1.5rem]  text-[60px]"
                      x="50%"
                      y="50%"
                      dy=".35em"
                      text-anchor="middle"
                    >
                      Accelor Microsystems
                    </text>
                  </svg>
                </div>
              </div>

              <div className="  overflow-hidden bg-gray-200 relative flex items-center justify-center max-sm:flex-col  max-sm:p-[0] py-[70px] px-[12%]">
                <SVGRND />
                <div className="absolute top-0 w-full h-full">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    width="100%"
                    height="100%"
                    viewBox="0 0 2 1"
                  >
                    <rect fill="#c2c2c2" width="2" height="1" />
                    <defs>
                      <linearGradient
                        id="a"
                        gradientUnits="userSpaceOnUse"
                        x1="0"
                        x2="0"
                        y1="0"
                        y2="1"
                      >
                        <stop offset="0" stop-color="#D2D2D2" />
                        <stop offset="1" stop-color="#DEDEDE" />
                      </linearGradient>
                      <linearGradient
                        id="b"
                        gradientUnits="userSpaceOnUse"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        <stop
                          offset="0"
                          stop-color="#E8E8E8"
                          stop-opacity="0"
                        />
                        <stop
                          offset="1"
                          stop-color="#E8E8E8"
                          stop-opacity="1"
                        />
                      </linearGradient>
                      <linearGradient
                        id="c"
                        gradientUnits="userSpaceOnUse"
                        x1="0"
                        y1="0"
                        x2="2"
                        y2="2"
                      >
                        <stop
                          offset="0"
                          stop-color="#E8E8E8"
                          stop-opacity="0"
                        />
                        <stop
                          offset="1"
                          stop-color="#E8E8E8"
                          stop-opacity="1"
                        />
                      </linearGradient>
                    </defs>
                    <rect x="0" y="0" fill="url(#a)" width="2" height="1" />
                    <g fill-opacity="0.5">
                      <polygon fill="url(#b)" points="0 1 0 0 2 0" />
                      <polygon fill="url(#c)" points="2 1 2 0 0 0" />
                    </g>
                  </svg>
                </div>
                <div className=" relative flex flex-[2]   flex-col leading-relaxed items-center justify-center  p-5 h-full ">
                  <AnimatedElement direction="from-left">
                    <h1 className="text-[2.3rem] max-sm:text-[24px]  font-semibold text-[#45484C] text-left">
                      {" "}
                      We have expertise in{" "}
                    </h1>
                    <div className="animation bg-gradient-to-r from-pink-900 to-purple-900  w-fit">
                      <span className="text-gray-300   font-extrabold">
                        Hardware designing
                        <br />
                        Software Development
                        <br />
                        Mechanical Designing
                        <br />
                        AI & Machine Learning
                        <br />
                      </span>
                    </div>
                    <h1 className="text-[2.3rem] max-sm:text-[24px] max-sm font-semibold text-[#45484C] text-left">
                      with inhouse{" "}
                      <span className="uppercase font-extrabold">R&D</span> and
                      state of the art{" "}
                      <span className="uppercase font-extrabold">
                        manufacturing facility{" "}
                        <span className="font-medium  lowercase">for</span>{" "}
                        prototype{" "}
                        <span className="font-medium lowercase">to</span> mass
                        production
                      </span>
                    </h1>
                  </AnimatedElement>
                </div>
                <div className="flex-1 relative">
                  <AnimatedElement direction="from-right">
                    <img className=" " width={400} src={hardware} />
                  </AnimatedElement>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-r from-[#6d222e] to-[#505da0] py-14 px-[12%] max-sm:px-3 flex flex-col gap-10">

              {/* MISSION */}
              <AnimatedElement direction="from-right">
                <div className="flex flex-row-reverse max-sm:flex-col max-sm:px-0">
                  <div className="flex-1 flex items-center justify-center">
                    <img
                      className="grayscale mix-blend-plus-lighter"
                      width={200}
                      src={MissionImg}
                    />
                  </div>
                  <div className="flex flex-col p-4 justify-center flex-[2]">
                    <div className="relative flex">
                      <RevealText
                        text="Our Mission"
                        css="text-[2.6rem] max-sm:text-[2rem] after:bg-[#672D44] text-gray-100 uppercase font-bold"
                      />
                    </div>
                    <AnimatedElement direction="from-down">
                      <p className="text-gray-100 poppins text-justify">
                        Focused on developing and manufacturing reliable
                        customized products build upon pioneering technologies
                        by experienced team upholding the highest standards of
                        quality.
                      </p>
                    </AnimatedElement>
                  </div>
                </div>
              </AnimatedElement>

              {/* VISION */}
              <AnimatedElement direction="from-left" delayAn="0.7">
                <div className="flex max-sm:flex-col max-sm:px-0">
                  <div className="flex-1 flex items-center justify-center">
                    <img
                      alt="vision"
                      className="grayscale mix-blend-screen"
                      width={180}
                      src={VisionImg}
                    />
                  </div>
                  <div className="flex p-4 flex-col justify-center flex-[2]">
                    <div className="relative flex">
                      <RevealText
                        text="Our Vision"
                        css="text-[2.6rem] text-[#fff] max-sm:text-[2rem] after:bg-[#613C60] uppercase font-bold"
                      />
                    </div>
                    <p className="text-justify text-[#fff] poppins">
                      To become the foremost authority and trusted partner in
                      Defence and Aerospace solutions.
                    </p>
                  </div>
                </div>
              </AnimatedElement>

              {/* QUALITY POLICY - NEW ✅ */}
              <AnimatedElement direction="from-right" delayAn="1">
                <div className="flex flex-row-reverse max-sm:flex-col max-sm:px-0">

                  {/* Icon Section */}
                  <div className="flex-1 flex items-center justify-center">
                    <MdWorkspacePremium
                      className="text-gray-300 mix-blend-plus-lighter opacity-80"
                      style={{ fontSize: "180px" }}
                    />
                  </div>

                  {/* Text Section */}
                  <div className="flex flex-col p-4 justify-center flex-[2] mt-8">
                    <div className="relative flex">
                      <RevealText
                        text="Quality Policy"
                        css="text-[2.6rem] max-sm:text-[2rem] after:bg-[#672D44] text-gray-100 uppercase font-bold"
                      />
                    </div>
                    <AnimatedElement direction="from-down">
                      <p className="text-gray-100 poppins text-justify">
                        Accelor Microsystems is committed to delivering
                        safe, reliable, and compliant products through excellence in design and manufacturing. We strive to meet the requirements of the aerospace and defence industries, as well as customers with critical performance needs.
                      </p>
                    </AnimatedElement>
                  </div>

                </div>
              </AnimatedElement>

            </div>
            <div className="bg-[#101010] py-10  px-10 max-sm:px-0  flex flex-col items-center justify-center">
              <div className="">
                <RevealText
                  text="Our Values"
                  css="text-[2.6rem] text-[#fff] max-sm:text-[2rem] after:bg-[#fff] uppercase font-bold"
                />
              </div>
              <div className=""></div>
              <Values2 />
            </div>

            <div className=" relative bg-black py-10 px-[10%] max-sm:px-2 ">
              <div className="absolute top-0 left-0 w-full h-full">
              </div>

              <div className="content">
                <h2 className=" max-sm:text-[2.5rem] text-[6rem]">
                  OUR STRENGTHS
                </h2>
                <h2 className=" max-sm:text-[2.5rem] text-[6rem]">
                  OUR STRENGTHS
                </h2>
              </div>
              <AnimatedElement direction="from-down">
                <div className="relative flex flex-wrap max-sm:flex-col mt-[200px] max-sm:mt-20 gap-7 justify-center">
                  <h1 className="text-[1.5rem] max-sm:text-[1.2rem] uppercase flex-1 text-center">
                    Inhouse{" "}
                    <span className="font-bold">
                      Design, Development, Manufacturing
                    </span>{" "}
                    & Qualification facility
                  </h1>
                  <h1 className="text-[1.5rem] max-sm:text-[1.2rem] uppercase flex-1 text-center">
                    Licenced{" "}
                    <span className="font-bold">Defence Manufacturer</span>
                  </h1>
                  <h1 className="text-[1.5rem] max-sm:text-[1.2rem] uppercase flex-1 text-center">
                    Prototype to{" "}
                    <span className="font-bold">
                      Mass production Capability
                    </span>
                  </h1>
                  <h1 className="text-[1.5rem] max-sm:text-[1.2rem] uppercase flex-1 text-center">
                    Inhouse{" "}
                    <span className="font-bold">
                      NABL Accredited Environment Test Laboratory
                    </span>
                  </h1>
                </div>
              </AnimatedElement>
              <div className="flex relative max-sm:flex-col gap-10 place-self-center  w-full py-10 mt-10 max-sm:py-4 justify-center">
                <div className="">
                  <div className=" flex items-center justify-center text-[3rem] oswald  font-semibold">
                    <NumberCounter from={0} to={80} />+
                  </div>
                  <p className="text-[1.1rem] max-sm:text-[16px]  font-medium">
                    Experienced Professionals
                  </p>
                </div>
                <div className="">
                  <div className=" flex items-center justify-center text-[3rem] oswald  font-semibold">
                    <NumberCounter from={0} to={15} />
                  </div>

                  <p className="text-[1.1rem] max-sm:text-[16px] font-medium">
                    Years of experience
                    <br />
                  </p>
                </div>
                <div className="">
                  <div className=" flex items-center justify-center text-[3rem]  font-semibold">
                    <NumberCounter from={0} to={100} duration={3} />+
                  </div>

                  <p className="text-[1.1rem] max-sm:text-[16px] font-medium">
                    Orders successfully delivered
                  </p>
                </div>
              </div>
            </div>

            <div className="w-full bg-gray-300 py-16 px-6">
              <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-20">

                {/* Certifications */}
                <div className="flex flex-col items-center gap-8 text-center">
                  <RevealText
                    text="OUR Certifications"
                    css="text-3xl sm:text-4xl text-[#425472] after:bg-[#425472] uppercase font-bold"
                  />

                  <div className="flex flex-wrap justify-center items-center gap-10 sm:gap-16">
                    <img
                      className="h-20 sm:h-24 w-auto object-contain mix-blend-multiply"
                      alt="ISO"
                      src={ISO}
                    />
                    <img
                      className="h-20 sm:h-24 w-auto object-contain mix-blend-multiply"
                      alt="AS9100"
                      src={AS9100}
                    />
                    <img
                      className="h-20 sm:h-24 w-auto object-contain mix-blend-multiply"
                      alt="ZED"
                      src={ZED}
                    />
                    <img
                      className="h-20 sm:h-28 w-auto object-contain mix-blend-multiply"
                      alt="NABL"
                      src={NABL}
                    />
                  </div>
                </div>

                {/* Memberships */}
                <div className="flex flex-col items-center gap-8 text-center">
                  <RevealText
                    text="OUR Memberships"
                    css="text-3xl sm:text-4xl text-[#425472] after:bg-[#425472] text-[#425472] uppercase font-bold"
                  />

                  <div className="flex flex-wrap justify-center items-center gap-10 sm:gap-16">
                    <img className="mix-blend-multiply w-24 sm:w-36" alt="SIDM" src={SIDM} />
                    <img
                      className="h-20 sm:h-28 w-auto object-contain"
                      alt="CII"
                      src={CII}
                    />
                    <img className="w-24 sm:w-36" alt="IPC" src={IPC} />
                  </div>
                </div>

              </div>
            </div>
            {/* OUR REGISTRATIONS */}
            <div className="flex flex-col items-center relative justify-center bg-gray-300 w-full">
              <div className="flex flex-col items-center gap-6 max-sm:py-[30px] py-[60px]">
                <RevealText
                  text="OUR Registrations"
                  css="text-[2.3rem] max-sm:text-[26px] text-[#425472] after:bg-[#425472] uppercase font-bold"
                />
                <div className="flex flex-wrap gap-[100px] max-sm:gap-6 items-center justify-center">

                  <img
                    className="mix-blend-multiply max-sm:w-[80px]"
                    width={200}
                    alt="MSME"
                    src={MSME}
                  />
                  <div className="flex flex-col items-center">
                    <img
                      className="mix-blend-multiply max-sm:w-[80px]"
                      width={200}
                      alt="Factory Act"
                      src={FactoryAct}
                    />
                    <p className="mt-2 text-sm font-medium text-gray-700">
                      Factory Act Registration
                    </p>
                  </div>
                  {/* <img
        className="mix-blend-multiply max-sm:w-[80px]"
        width={100}
        alt="registration"
        src={""}  // ← Add your image path
      />
      <img
        className="mix-blend-multiply max-sm:w-[80px]"
        width={100}
        alt="registration"
        src={""}  // ← Add your image path
      /> */}
                </div>
              </div>
            </div>
            <div className="flex flex-col relative bg-gray-200 py-[50px] overflow-hidden  max-sm:py-[25px]">
            </div>
          </motion.div>
        </div>
      </TransitionPage>
    </>
  );
}

export default Home;
